export default "__VITE_ASSET__D6i4ZW0K__"